import styled from "styled-components"

export const Container = styled.div`
  position: fixed;
  right: 10px;
  bottom: 30px;
  z-index: 2;

  & > * {
    display: block;
    margin-bottom: 5px;
  }

  @media (max-width: 768px) {
    right: 2.5px;
    bottom: 5px;
  }
`
